import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = {
  key: 1,
  class: "w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainViewCard = _resolveComponent("MainViewCard")!
  const _component_FarmToFarmPage = _resolveComponent("FarmToFarmPage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.currentStep < 2)
            ? (_openBlock(), _createBlock(_component_MainViewCard, {
                key: 0,
                class: "max-w-4xl px-4 py-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_Transition, {
                    name: "fade",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
                        state: _ctx.state,
                        onNext: _ctx.next,
                        onBack: _ctx.previous
                      }, null, 40, ["state", "onNext", "onBack"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.selection)
                  ? (_openBlock(), _createBlock(_component_FarmToFarmPage, {
                      key: 0,
                      selection: _ctx.selection,
                      onReset: _ctx.onReset
                    }, null, 8, ["selection", "onReset"]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      })
    ])
  ]))
}